export var creditCards = {
  offer_api: '/marketplace/offers/v0/credit_cards/search'
};